<template>
  <time class="c-frais-count-down" :datetime="datetimeTarget">
    <span class="c-frais-count-down__days">{{ days }}</span>
    <span class="c-frais-count-down__colon">:</span>
    <span class="c-frais-count-down__hours">{{ hours }}</span>
    <span class="c-frais-count-down__colon">:</span>
    <span class="c-frais-count-down__minutes">{{ minutes }}</span>
    <span class="c-frais-count-down__colon">:</span>
    <span class="c-frais-count-down__seconds">{{ seconds }}</span>
  </time>
</template>

<script>
export default {
  name: 'ComponentsFraisCountDown',
  props: {
    datetimeTarget: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      diffMilisecond: new Date(this.datetimeTarget) - new Date(),
    }
  },
  computed: {
    days() {
      return Math.floor(this.diffMilisecond / (1000 * 60 * 60 * 24))
        .toString()
        .padStart(2, '0')
    },
    hours() {
      return (Math.floor(this.diffMilisecond / (1000 * 60 * 60)) % 24)
        .toString()
        .padStart(2, '0')
    },
    minutes() {
      return (Math.floor(this.diffMilisecond / (1000 * 60)) % 60)
        .toString()
        .padStart(2, '0')
    },
    seconds() {
      return (Math.floor(this.diffMilisecond / 1000) % 60)
        .toString()
        .padStart(2, '0')
    },
  },
  created() {
    this.intervalId = setInterval(() => {
      this.diffMilisecond = new Date(this.datetimeTarget) - new Date()
    }, 1000)
  },
  beforeUnmount() {
    clearInterval(this.intervalId)
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-frais-count-down {
  display: flex;
  font-size: 60px;

  &__days,
  &__hours,
  &__minutes,
  &__seconds {
    display: flex;
    justify-content: center;
    line-height: 1;
    position: relative;
    text-shadow: 0 0 10px rgba(#000, 0.3);
    width: 80px;

    &::before {
      font-size: 22px;
      left: 0;
      letter-spacing: 0;
      position: absolute;
      top: 100%;
      width: 100%;
    }
  }

  &__days::before {
    content: 'days';
  }
  &__hours::before {
    content: 'hours';
  }
  &__minutes::before {
    content: 'min';
  }
  &__seconds::before {
    content: 'sec';
  }

  &__colon {
    line-height: 1;
    position: relative;
    top: -8px;
  }
}
</style>
